export const siteSettings = {
  name: "Zen Craft Capital Ace",
  link: "https://zencraftcapitalace.net",
  email: "support@zencraftcapitalace.net",
  appLink: "https://app.zencraftcapitalace.net",
};
